import { SvgIcon } from '@mui/material';
import { memo } from 'react';

function ConsolidationFlow({ ...props }) {
  return (
    <SvgIcon width='24' height='24' {...props}>
      <path
        d='m 4.5002,16.5048 -5e-5,-8.99913 8.810678,3.993672 -0.0029,0.01236 6.0595,-0.0069 -2.0942,-2.10003 0.7077,-0.72693 3.327,3.32696 -3.327,3.3077 -0.7135,-0.727 2.1,-2.0807 -6.0595,0.0069 z m 7.8077,-4.512425 v -0.01011 L 5.30786,8.9416719 v 6.2393031 z'
        stroke='none'
        fill='currentColor'
      />
    </SvgIcon>
  );
}

export default memo(ConsolidationFlow);

